import React from 'react'

export default function Disclamier() {
    return (
        <div>
            <div className="ui-typo--body2 ui-font-weight--light app-summary">
                <span> <strong>Disclaimer: </strong></span>
                <ul>
                    <li>
                        Please note that these are not my designs nor do I own any of the projects, I was part of the team who have developed the project, and my role was coding!
                    </li>
                    <li>
                        Have any doubts / questions, drop me a line. &nbsp;
                        <a href="mailto:bhrthkshr@gmail.com" className="ui-theme--primary">bhrthkshr@gmail.com</a>
                    </li>
                </ul>
            </div>
        </div>
    )
}
